import { Injectable } from '@angular/core';
import { ContentfulService } from 'src/app/shared/services/contentful.service';
import { PageId } from 'src/app/shared/utilities/pageids.enum';
import { MetaService } from 'src/app/shared/services/meta.service';

@Injectable({
  providedIn: 'root',
})
export class TermpageService {
  constructor(
    private contentful: ContentfulService,
    private meta: MetaService
  ) {}

  gettermPageData() {
    this.contentful.getEntries(
      Object.assign({
        content_type: PageId.otherCompanyPages,
        include: 10,
      })
    );
  }
}
